import React, {createContext, useEffect, useState} from 'react';
import './App.css';
import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/800.css';
import '@fontsource/inter/900.css';
import {Grid} from "@mui/material";
import Pagina from "./Pagina/Pagina";
import {obtenerCol} from "./Servicios/BD/obtenerCol";
import {guardarObjLocal} from "./Servicios/BDLocal/guardarObjLocal";

export const contexData = createContext()

function App() {
    const [categorias, setCategorias] = useState([])
    const [subCatEscogida, setSubCatEscogida] = useState('')
    const [openCategorias, setOpenCategorias] = useState(false)
    const [iconoCat, setIconoCat] = useState('')
    const [rutas, setRutas] = useState([])
    const [ultimosVistos, setUltimosVistos] = useState([])


    const valoresProvider = {
        categorias,
        subCatEscogida,
        setSubCatEscogida,
        openCategorias,
        setOpenCategorias,
        iconoCat,
        setIconoCat,
        rutas,
        setRutas,
        ultimosVistos,
        setUltimosVistos
    }

    const {Provider} = contexData;

    useEffect(() => {


        obtenerCol('categorias').then((dox) => {
            setCategorias(dox.data)
            guardarObjLocal({key: 'vCategorias', obj: dox.data})
            guardarObjLocal({key: 'vCategorias', obj: dox.data})
        })


        obtenerCol('rutas').then((dox) => {
            setRutas(dox.data)
        })

    }, []);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Provider value={valoresProvider}>
                <Pagina/>
            </Provider>
        </Grid>
    );
}

export default App;
